import {customElement, property, state} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import {SbkModal} from "@/components/modal/modal.ts";
import {autoLogoutStyle} from "@/components/auto-logout/auto-logout.styles.ts";
import {unsafeHTML} from "lit/directives/unsafe-html.js";

@customElement('sbk-auto-logout')
export class SbkAutoLogout extends LitElement {

    @property({attribute: 'initial-time-until-logout', type: Number})
    initialTimeUntilLogout = 0;

    @property({attribute: 'time-until-logout-show-modal', type: Number})
    timeUntilLogoutShowModal = 0;

    @property({attribute: 'logout-page'})
    logoutPage = '';

    @property({attribute: 'logout-error-page'})
    logoutErrorPage = '';

    @property({attribute: 'modal-heading'})
    modalHeading = '';

    @property({attribute: 'modal-text'})
    modalText = '';

    @property({attribute: 'reset-countdown-button-label'})
    resetCountdownButtonLabel = '';

    @state()
    actualTime = 0;

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.actualTime = this.initialTimeUntilLogout;
        this.dispatchTimeUpdate()
        setTimeout(this.countdown, 1000)
    }

    static get styles() {
        return autoLogoutStyle;
    }

    render() {
        return html`
            <sbk-modal id="autoLogoutHint" heading=${this.modalHeading}>
                <p>${unsafeHTML(this.replaceText())}</p>
                <sbk-button slot="footer" @click=${this.resetCountdown}>${this.resetCountdownButtonLabel}</sbk-button>
            </sbk-modal>
        `;
    }

    private replaceText(): string {
        return this.modalText.replace('%1$s', `<span class="time">${this.fmtSecToMinSec(this.actualTime)}</span>`)
    }

    fmtSecToMinSec(s: number): string{
        const min = (s-(s%=60))/60;
        return (9<min?'':'0')+min+(9<s?':':':0')+s
    }

    countdown = () => {
        this.actualTime = this.actualTime - 1
        const timeMod: number = this.actualTime % 60

        if (this.actualTime !== 0 && timeMod !== 0 && this.actualTime !== this.timeUntilLogoutShowModal) {
            this.dispatchTimeUpdate()
            // continue countdown
            setTimeout(this.countdown, 1000)
        } else if (this.actualTime !== 0 && timeMod === 0 && this.actualTime !== this.timeUntilLogoutShowModal) {
            this.dispatchTimeUpdate()
            setTimeout(this.countdown, 1000)
        } else if (this.actualTime !== 0 && timeMod === 0 && this.actualTime === this.timeUntilLogoutShowModal) {
            this.showModal()
            this.dispatchTimeUpdate()
            // continue countdown
            setTimeout(this.countdown, 1000)
        } else if (this.actualTime !== 0 && timeMod !== 0 && this.actualTime === this.timeUntilLogoutShowModal) {
            this.showModal()
            this.dispatchTimeUpdate()
            // continue countdown
            setTimeout(this.countdown, 1000)
        } else {
            // when the countdown runs out, logout the user
            window.location.href = this.logoutPage
        }
    }

    resetCountdown() {
        const logoutErrorPage: string = this.logoutErrorPage
        // reset HCV countdown
        const xhr: XMLHttpRequest = new XMLHttpRequest()
        const host = window.location.origin
        xhr.open('GET', `${host}/ajax/ogs/resetCountdown`, true)
        xhr.send()
        xhr.onload = () => {
            const data: string = xhr.responseText

            if (data !== 'ok') {
                // if the session cannot be extended, logout the user
                window.location.href = logoutErrorPage
            } else {
                this.actualTime = this.initialTimeUntilLogout;
                this.closeModal();
            }
        }
    }

    showModal() {
        const modal: SbkModal | null = this.renderRoot.querySelector(`sbk-modal`)

        if (modal) {
            const dialog: HTMLDialogElement | null = modal.renderRoot.querySelector('dialog');
            dialog?.showModal()
        }
    }

    closeModal() {
        const modal: SbkModal | null = this.renderRoot.querySelector(`sbk-modal`)

        if (modal) {
            const dialog: HTMLDialogElement | null = modal.renderRoot.querySelector('dialog');
            dialog?.close()
        }
    }

    dispatchTimeUpdate() {
        const event = new CustomEvent('sbk-update-logout-countdown',
            {
                detail: {remainingSeconds: this.actualTime},
                bubbles: true
            });
        this.dispatchEvent(event);
    }

}
